import { jwtDecode } from "jwt-decode";
import type { RootStore, AppDispatch } from "./store";
import { TypedUseSelectorHook, useSelector, useDispatch } from "react-redux";
import { DecodedTokenType } from "./types";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootStore> = useSelector;
export const isTokenExpired = (token: string): boolean => {
  if (!token) return true; // Return true if token is not provided
  try {
    const decoded: DecodedTokenType = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    return currentTime > decoded.exp; // Check if the current time is greater than the expiration time
  } catch (error) {
    console.error("Failed to decode token:", error);
    return true; // If decoding fails, consider the token expired
  }
};
export function normalizeEmailHTML(html: string): string {
  if (!html) return "";

  let output = html;

  // Remove inline widths that break layout
  output = output.replace(/width:\s*\d+px/gi, "width: 100%");

  // Remove max-width from editor artifacts
  output = output.replace(/max-width:\s*\d+px/gi, "max-width: 100%");

  // Ensure images never overflow
  output = output.replace(
    /<img([^>]*)>/gi,
    `<img style="max-width:100%;height:auto;object-fit:contain" $1>`
  );

  // Remove empty paragraphs that create big gaps
  output = output.replace(/<p>\s*<\/p>/g, "");

  // Fix tables expanding beyond container
  output = output.replace(
    /<table([^>]*)>/gi,
    `<table style="width:100%;border-collapse:collapse" $1>`
  );

  // Remove Apple & Gmail auto-styles
  output = output.replace(/mso-[a-z-]+:[^;"]+;?/gi, "");

  return output;
}
